import * as t from 'app/actions/cafeteria/finances';

export const initState = {
  result: 'none',
  err: null,
  loading: true,
  data: {},
};

function date(state = initState, action) {
  switch (action.type) {
    case t.CAFETERIA_FINANCES_REQUEST:
      return {
        ...state,
        loading: true,
        err: null,
      };

    case t.CAFETERIA_FINANCES_FAIL:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    case t.CAFETERIA_FINANCES_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        err: null,
        loading: false,
      };

    default:
      return state;
  }
}

function student(state = {}, action) {
  return {
    ...state,
    [action.payload.date]: date(state[action.payload.date], action),
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case t.CAFETERIA_FINANCES_REQUEST:
    case t.CAFETERIA_FINANCES_FAIL:
    case t.CAFETERIA_FINANCES_SUCCESS:
      return {
        ...state,
        [action.payload.studentId]: student(state[action.payload.studentId], action),
      };

    default:
      return state;
  }
}
